export default __webpack_public_path__ + "static/media/affiliate-feature-tracking.dc90f56f.svg";